const no = {
   
    message: {
        title1: 'Fjernstyring av smarte hjem, teknologi, sikkerhet og bekymringsløshet',
        content1: 'AigoSmart hjelper deg med å administrere og kontrollere smarte hjemmeelektronikk eksternt. Enheter kan oppfatte og samhandle med hverandre, slik at du med ett trykk kan sette hjemmets ulike apparater i den forhåndsdefinerte tilstanden din, og dermed skape et sikkert og bekymringsløst smart hjem.',
        title2: 'AigoSmart er det nye undermerket til Aigostar',
        content2: 'Produktene selges for øyeblikket til land og regioner som Spania, Portugal, Frankrike, Italia, Nederland, Tyskland, Finland, Danmark, Polen, Russland, Hellas, Østerrike, Sveits, Tsjekkia, Ungarn, Slovakia og andre europeiske land.',
        content3: 'AIGOSTAR har kontinuerlig tatt topplasseringer for flere kjøkken- og strykeapparater i små størrelser.',
        content4: 'Blant de ti beste i salgsrangeringen.',
        title3: 'Merkeære',
        content5: 'Raskt. Åpent. Innovativt. Vedvarende.',
        loading: 'Laster',
        submit: 'Send inn',
        contactUs: 'Kontakt oss',
        privacy: 'Personvernregler',
        policy: 'Servicepolitikk',
        download: 'Nedlasting',
    },
    
    wisdomleads: {
        title1: 'Fjernstyring av smarte hjem, teknologi, sikkerhet og bekymringsløshet',
        content1: 'Wisdomleads hjelper deg med å administrere og kontrollere smarte hjemmeelektronikk eksternt. Enheter kan oppfatte og samhandle med hverandre, slik at du med ett trykk kan sette hjemmets ulike apparater i den forhåndsdefinerte tilstanden din, og dermed skape et sikkert og bekymringsløst smart hjem.',
        title2: 'Wisdomleads er det nye undermerket til Aigostar',
        content2: 'Produktene selges for øyeblikket til land og regioner som Spania, Portugal, Frankrike, Italia, Nederland, Tyskland, Finland, Danmark, Polen, Russland, Hellas, Østerrike, Sveits, Tsjekkia, Ungarn, Slovakia og andre europeiske land.',
        content3: 'Wisdomleads har kontinuerlig tatt topplasseringer for flere kjøkken- og strykeapparater i små størrelser.',
        content4: 'Blant de ti beste i salgsrangeringen.',
        title3: 'Merkeære',
        content5: 'Raskt. Åpent. Innovativt. Vedvarende.',
        loading: 'Laster',
        submit: 'Send inn',
        contactUs: 'Kontakt oss',
        privacy: 'Personvernregler',
        policy: 'Servicepolitikk',
        download: 'Nedlasting',
    },

    v119:{

        password: 'Passord',
        back: 'Tilbake',
        account: 'Skriv inn kontonummer',
        VerifyAccount: 'Bekreft konto',
        confire: 'Bekreft',
        complete: 'Fullfør',
        loginAccount: 'Logg inn på kontoen',
        VerifyCode: 'Bekreftelseskode',
        preview: 'Forrige',
        next: 'Neste',
        enterEmail: 'Skriv inn e-post',
        phone: 'Logg inn med mobil',
        email: 'Logg inn med e-post',
        pleaseenter: 'Vennligst skriv inn',
        emailError: 'Feil e-postformat',
        phoneError: 'Feil telefonnummerformat',
        qcCodeError: 'Feil bekreftelseskode',
        sendCode: 'Send bekreftelseskode',
        reSend: 'Send på nytt',
        tip1: 'Før du sender inn en forespørsel om avmelding, vil plattformen verifisere følgende informasjon for å sikre konto- og eiendomssikkerhet:',
        tip2: 'Kontoen er i sikker tilstand',
        tip3: 'Ingen sensitive operasjoner, som binding av mobiltelefon / e-post, endring av passord, bytte av innloggingsenhet, etc., innen 15 dager',
        tip4: 'Kontoen har ingen kjørende smarte enheter',
        tip5: 'Du er frakoblet (eller ikke bundet) smarte enheter',
        tip6: 'Kontoen har ingen eiendomsrisiko',
        tip7: 'Ingen sensitive operasjoner, som endring av passord, ingen kjøpshistorikk, ingen binding av bankkort, etc., innen 15 dager',
        accountCancellation: 'Kontoavmelding',
        tip8: 'Takk for følget gjennom hele reisen. Dessverre vil ikke AigoSmart lenger kunne tilby tjenester for deg. Før du melder deg av, vil vi gjennomgå kontoen din igjen. Vær oppmerksom på at følgende informasjon vil bli slettet etter vellykket avmelding.',
        tip9: 'Takk for følget gjennom hele reisen. Dessverre vil ikke Wisdomleads lenger kunne tilby tjenester for deg. Før du melder deg av, vil vi gjennomgå kontoen din igjen. Vær oppmerksom på at følgende informasjon vil bli slettet etter vellykket avmelding.',
        tip10: '1. Informasjon om tilkoblede moduler, rom, hjem og enheter vil bli permanent slettet og kan ikke gjenopprettes',
        tip11: '2. Informasjon om scener, automatisering, tilpassede oppskrifter, etc. vil bli permanent slettet og kan ikke gjenopprettes',
        tip13: '3. Alle kontoinformasjon, tjenesteregistreringer, forbruksopplysninger, etc. på plattformen vil bli permanent slettet og kan ikke gjenopprettes',
        tip14: '4. Du vil ikke kunne logge inn eller bruke AigoSmart-kontoen din lenger. Familien / vennene dine vil ikke kunne dele enheter med deg gjennom denne kontoen',
        tip14w: '4. Du vil ikke kunne logge inn eller bruke Wisdomleads-kontoen din lenger. Familien / vennene dine vil ikke kunne dele enheter med deg gjennom denne kontoen',
        tip15: '5. Personlig informasjon og historiske meldinger (inkludert profilbilde, kallenavn, enhetsalarmer, plattformvarslinger, hjemmemeldinger, etc.) på AigoSmart-kontoen din vil ikke kunne gjenopprettes',
        tip15w: '5. Personlig informasjon og historiske meldinger (inkludert profilbilde, kallenavn, enhetsalarmer, plattformvarslinger, hjemmemeldinger, etc.) på Wisdomleads-kontoen din vil ikke kunne gjenopprettes',
        tip16: '6. Du må håndtere kontoens midler (poeng, medlemsnivå, kvalifikasjoner, bestillinger, kuponger, rekvisita og annen verdifull tjeneste) forsvarlig før du logger deg av. Etter at kontoen er avmeldt, vil det anses som at du gir opp på egen hånd og ikke lenger kan bruke den. Du forstår og godtar at AigoSmart ikke kan hjelpe deg med å gjenopprette nevnte tjenester',
        tip16w: '6. Du må håndtere kontoens midler (poeng, medlemsnivå, kvalifikasjoner, bestillinger, kuponger, rekvisita og annen verdifull tjeneste) forsvarlig før du logger deg av. Etter at kontoen er avmeldt, vil det anses som at du gir opp på egen hånd og ikke lenger kan bruke den. Du forstår og godtar at Wisdomleads ikke kan hjelpe deg med å gjenopprette nevnte tjenester',
        tip17: 'Plattformen vil behandle forespørselen din og slette alle dataene dine innen 15 dager. Vennligst ikke logg inn på plattformen i løpet av disse 15 dagene for å sikre en smidig avmeldingsprosess',
        tip18: 'Skriv inn bekreftelseskoden',
        tip12: 'Du kan for øyeblikket ikke melde deg av',
        tip20: 'Forslag til plattformen (valgfritt)',
        errorMsg1: 'Brukeren eksisterer ikke',
        errorMsg2: 'Brukeren har allerede søkt om avmelding',
        errorMsg3: 'Brukeren har gjennomført sensitive operasjoner innen 15 dager, som endring av passord, bytte av enhet, etc., og kan derfor ikke melde seg av',
        errorMsg4: 'Feil bekreftelseskode',
        tip21: "Vennligst vent, utfører maskinverifisering"

    }   
   
    
}

export default no;